import React from 'react';
import PropTypes from 'prop-types';
import { useTranslation } from 'react-i18next';
import { SelectField, Button, Helper } from 'Components';
import AppContext from 'src/AppContext';
import './NavDesktopFilter.css';

const NavDesktopFilter = ({
  options,
  filterFieldValue,
  filterFieldLabel,
  filterItemValue,
  setAppState,
}) => {
  const { t } = useTranslation();
  return (
    <header className="nav__desktop__filter">
      <h2>{filterFieldLabel}</h2>
      <ul>
        <Helper text={t('tutorials:dashboardOverview.5')}>
          <li className={`nav__desktop__item ${(filterItemValue === '') ? 'nav__desktop__item--active' : ''}`}>
            <Button
              className="nav__desktop__item__pin"
              style={{ visibility: 'hidden' }}
            >
              <i className="material-icons">turned_in</i>
            </Button>
            { (filterFieldLabel !== '') &&
            <Button
              className="nav__desktop__item__link"
              onClick={() => setAppState({ filterItemValue: '' })}
            >
              {`${t('nav:View All')} ${filterFieldLabel}s`}
            </Button>
          }
          </li>
        </Helper>
      </ul>
      <Helper text={t('tutorials:dashboardOverview.3')}>
        <SelectField
          options={options}
          onChange={e =>
          setAppState({ filterFieldValue: e.target.value, filterItemValue: '' })}
          value={filterFieldValue}
        />
      </Helper>
    </header>
  );
};

NavDesktopFilter.propTypes = {
  filterFieldValue: PropTypes.string,
  filterFieldLabel: PropTypes.string,
  options: PropTypes.arrayOf(PropTypes.shape({
    value: PropTypes.string,
    label: PropTypes.string,
  })),
  filterItemValue: PropTypes.string,
  setAppState: PropTypes.func,
};

export default (props => (
  <AppContext.Consumer>
    {context => (
      <NavDesktopFilter
        {...props}
        setAppState={context.setAppState}
      />
    )}
  </AppContext.Consumer>
));



// WEBPACK FOOTER //
// ./src/containers/Nav/NavDesktop/NavDesktopFilter/NavDesktopFilter.jsx